import React from 'react';
import './Projects.css';
import { Link } from "react-router-dom";

function Projects() {
  return (
    <div className="projects-container">
     <h1>My Projects</h1>
     <ul>
        <li><Link to="/homelab">Home Lab</Link></li>
        <li><Link to="/bigfoot">The Official Indiana Bigfoot Conference Website</Link></li>
        <li><Link to="/partical">Particle Morph</Link></li>
     </ul>
    </div>
  );
}

export default Projects;